import { ILoginService } from "@/services/login/ILoginService";
import { LoginService } from "@/services/login/LoginService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";

export function bindLoginService(container:Container) {
    container.bind<ILoginService>(IoCTypes.LoginService).to(LoginService)
}